import React from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Chip, Tooltip } from "@mui/material";

interface EasyWinChipProps {
  tooltipText: string;
}

export const EasyWinChip: React.FC<EasyWinChipProps> = ({ tooltipText }) => (
  <Chip
    variant="status"
    label="Easy win"
    color="success"
    sx={{ ml: 1, mb: 0.3 }}
    icon={
      <Tooltip title={tooltipText} arrow>
        <InfoOutlinedIcon />
      </Tooltip>
    }
  />
);
